/**
 * This function is used for display Toast msg through out the site with custom message, class & icon
 * Default value set for display timing, classes
 * To add more customization other methods to ToastNotification and set them to init notification 
 */

var notification = new ToastNotification({
  topPos: $(window).width() > 768 ? $('.sticky-component').innerHeight() + 16 : $('.sticky-component').innerHeight() + 19,
  classNames: 'active',
  icons: 'icon-clickToCopy', 
  autoClose: true,
  autoCloseTimeout: 3000 
});

function ToastNotification(option) {
  var el = this
  var toastWrapper = $("<div class='toast-container'><div class='toast-body'><i class='icon'></i><span class='toast-message'></span></div></div>");

  $('body').append(toastWrapper);

  el.self = $(".toast-container");
  el.close = this.self.find(".close");
  el.message = el.self.find(".toast-message");
  el.icon = el.self.find(".icon");
  el.top = option.topPos;
  el.classNames = option.classNames;
  el.icons = option.icons;
  el.autoClose =
    typeof option.autoClose === "boolean" ? option.autoClose : false;
  el.autoCloseTimeout =
    option.autoClose && typeof option.autoCloseTimeout === "number"
      ? option.autoCloseTimeout
      : 3000;

  // Methods
  el.reset = function () {
    el.message.empty();
    el.self.removeClass(el.classNames);
  };
  el.show = function (msg, type, icon) {
    el.reset();
    el.self.css("top", el.top);
    el.message.html(msg);
    el.self.addClass(type);
    el.icon.addClass(icon);

    if (el.autoClose) {
      setTimeout(function () {
        el.hide();
      }, el.autoCloseTimeout);
    }
  };
  el.hide = function () {
    el.self.removeClass('animate__fadeInDownToast').addClass('animate__fadeInUpToast');
    setTimeout(() => {
      el.reset();
      el.self.css("top", '');
      el.self.removeClass('animate__fadeInUpToast');
    }, 300);
  };

  el.close.on("click", this.hide);
}

export default {
  init: function (typo, id, icon) {
    notification.show(typo, id, icon);
  },
}  